export default __webpack_public_path__ + "static/media/new-article-icon.f152b1f2.svg";